import { $apiV1 } from "../config/api";

const AI_TEST_API_BASE_URL = "https://api-v1.smrtstats.com/api/v1";

export const callAiTranscribe = async ({ file, model, prompt }) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("model", model);
  formData.append("prompt", prompt);

  return $apiV1.post("/ai/transcribe", formData, {
    baseURL: AI_TEST_API_BASE_URL,
  });
};

export const callAiSpeech = async ({ model, voice, input }) => {
  return $apiV1.post(
    "/ai/speech",
    {
      model,
      voice,
      input,
    },
    {
      baseURL: AI_TEST_API_BASE_URL,
      responseType: "blob",
    }
  );
};

export const callAiMessages = async ({
  model,
  max_tokens,
  system,
  tools,
  messages,
}) => {
  return $apiV1.post(
    "/ai/messages",
    {
      model,
      max_tokens,
      system,
      tools,
      messages,
    },
    {
      baseURL: AI_TEST_API_BASE_URL,
    }
  );
};
